import { AlertTriangle } from 'lucide-react'
import { Modal } from './Modal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  isPending?: boolean
}

export function ConfirmDialog({
  isOpen, onClose, onConfirm,
  title, message,
  confirmLabel = 'Delete',
  isPending = false,
}: Props) {
  return (
    <Modal open={isOpen} onClose={onClose} size="sm">
      <div className="flex flex-col items-center gap-3 py-2 text-center">
        <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
          <AlertTriangle className="w-6 h-6 text-red-600" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>
          <p className="text-sm text-gray-500">{message}</p>
        </div>
        <div className="flex gap-2 w-full pt-1">
          <button
            onClick={onClose}
            className="btn btn-secondary btn-sm flex-1"
          >
            Cancel
          </button>
          <button
            onClick={() => { onConfirm(); onClose() }}
            disabled={isPending}
            className="btn btn-sm flex-1 bg-red-600 hover:bg-red-700 text-white border-red-600"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  )
}
